import { useState } from 'react'
import SnsShareDialog from './SnsShareDialog'

interface SnsShareButtonProps {
  shareUrl?: string
  shareText?: string
  shareHashtags?: string[]
  variant?: 'primary' | 'secondary' | 'minimal'
  size?: 'sm' | 'md' | 'lg'
}

/**
 * SNSシェアボタンコンポーネント
 */
export default function SnsShareButton({
  shareUrl = typeof window !== 'undefined' ? window.location.href : '',
  shareText = 'スタンプラリーに参加しています！',
  shareHashtags = ['スタンプラリー'],
  variant = 'primary',
  size = 'md',
}: SnsShareButtonProps) {
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  const variantClasses = {
    primary: 'bg-main hover:opacity-90 text-sub',
    secondary: 'bg-gray-200 hover:bg-gray-300 text-gray-700',
    minimal: 'bg-transparent hover:bg-gray-100 text-gray-700 border-2 border-gray-300',
  }

  const sizeClasses = {
    sm: 'px-3 py-1.5 text-xs',
    md: 'px-4 py-2 text-sm',
    lg: 'px-6 py-3 text-base',
  }

  return (
    <>
      <button
        type="button"
        onClick={() => setIsDialogOpen(true)}
        className={`${variantClasses[variant]} ${sizeClasses[size]} rounded-full font-bold transition-all flex items-center justify-center space-x-2 shadow-sm`}
      >
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z"
          />
        </svg>
        <span>シェア</span>
      </button>

      <SnsShareDialog
        isOpen={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        shareUrl={shareUrl}
        shareText={shareText}
        shareHashtags={shareHashtags}
      />
    </>
  )
}
